export function formatInvoiceDuration(hours: number | string | null | undefined): string {
    const numericHours = Number(hours);
    const minutes = Number.isFinite(numericHours) ? Math.max(0, Math.round(numericHours * 60)) : 0;
    return `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}`;
}
